import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';

interface EmailEnviarDTO{
  nome: string,
  remetente: string,
  mensagem:string
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private baseApiUrl = `${environment.apiUrl}/email`;

  constructor(private caqRequestService: CaqRequestService) {}

  public enviarEmail(email:EmailEnviarDTO): Promise<any> {

    return firstValueFrom(
      this.caqRequestService.post<void>(this.baseApiUrl,email).pipe(
        map((response) => response)
      )
    );
  }

}
